import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { requestConst } from 'src/app/core/constants/request.const';
import { SharedConst } from 'src/app/core/constants/shared.constant';
import { CommonService } from 'src/app/core/services/common.service';
import { DeleteLineItemDto } from '../../models/common/delete-line-item.model';
import { LineAssignmentDto } from '../../models/common/line-assignment.model';
import { NewActionInputParam } from '../../models/common/new-action-input-param.model';
import { TempActionRequestDto } from '../../models/temp-actions/temp-action-request.module';
import { RequestLineService } from '../../services/request-line.service';
import { TempActionService } from '../../services/temp-action.service';
import { ChipRemoveEvent } from '@progress/kendo-angular-buttons';
import { EquipmentDataService } from '../../models/common/equipment-data.service';
import { EquipmentDto } from '../../models/common/equipment.model';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { DialogRef, DialogService, DialogCloseResult } from '@progress/kendo-angular-dialog';

@Component({
    selector: 'app-sar-new-action',
    templateUrl: './sar-new-action.component.html',
    styleUrls: ['./sar-new-action.component.scss'],
    standalone: false
})
export class SarNewActionComponent implements OnInit, OnDestroy {
  isChangeSAR: boolean = false;
  isAddNewItem: boolean = false;
  equipmentSelect = false;
  selectedActionType: string = '0';
  selectedChangeType: string = '0';
  selectedEquipment: string;
  equipment: string[] = [];

  data: string[] = [];
  selectedEquipments: any[] = [];
  equipmentSelectPlaceHolder: string;
  equipmentCriticality = "-";
  itemPartRanking = "-";
  requestId: number = 0;
  requestNumber: number = 0;
  requestIssueId: number = 0;
  actionNumber: number = 0;
  action: string = '';
  isNew: boolean = false;
  addedLineNumber: number = 0;
  newActionInputParam: NewActionInputParam = {};
  tempActionRequest: TempActionRequestDto = new TempActionRequestDto();
  lineAssignment?: LineAssignmentDto = new LineAssignmentDto();
  deleteLineItem: DeleteLineItemDto = new DeleteLineItemDto();
  isGoupSelected: boolean = true;
  isDraftavailable: boolean = false;
  isInventoryLevelUpdate: boolean = false;
  isABU: boolean = false;
  isEquipmentShown: boolean = true;
  constructor(private dialogService: DialogService,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private tempActionService: TempActionService,
    private requestLineService: RequestLineService,
    private equipmentDataService: EquipmentDataService) {
    const stateData: any = this.router.currentNavigation()?.extras.state;
    if (!this.commonService.isNullOrEmptyOrUndefined(stateData)) {
      this.newActionInputParam.isNew = stateData['isNew'];
      this.newActionInputParam.requestId = stateData['requestId'];
      this.newActionInputParam.requestNumber = stateData['requestNumber'];
      this.newActionInputParam.requestIssueId = stateData['requestIssueId'];
      this.newActionInputParam.changeType = stateData['changeType'];
      this.newActionInputParam.actionNumber = stateData['actionNumber'];
      this.newActionInputParam.assetName = stateData['assetName'];
      this.newActionInputParam.requestStateId = stateData['requestStateId'];
      this.newActionInputParam.isEdit = stateData['isEdit'];
      this.newActionInputParam.requestLineId = stateData['requestLineId'];
      this.addedLineNumber = stateData['requestLineId'];
      sessionStorage.setItem('sarnewaction', JSON.stringify(stateData));
    }
    else {
      let sessionState = JSON.parse(sessionStorage.getItem('sarnewaction')!);
      if (!this.commonService.isNullOrEmptyOrUndefined(sessionState)) {
        this.newActionInputParam.isNew = sessionState.isNew;
        this.newActionInputParam.requestId = sessionState.requestId;
        this.newActionInputParam.requestNumber = sessionState.requestNumber;
        this.newActionInputParam.requestIssueId = sessionState.requestIssueId;
        this.newActionInputParam.changeType = sessionState.changeType;
        this.newActionInputParam.actionNumber = sessionState.actionNumber;
        this.newActionInputParam.assetName = sessionState.assetName;
        this.newActionInputParam.isEdit = sessionState.isEdit;
        this.newActionInputParam.requestLineId = sessionState.requestLineId;
        this.addedLineNumber = sessionState.requestLineId;
      }
    }
  }

  ngOnInit() {
    this.isABU = this.commonService.getUserBUName() === 'ABU';
    if (this.newActionInputParam.changeType === 'Extension MRP Update' && this.isNew === false) {
      this.isChangeSAR = true;
      this.selectedActionType = '2';
      this.selectedChangeType = '2';
      this.isInventoryLevelUpdate = false;
    }
    else if (this.newActionInputParam.changeType === 'Inventory Level Update' && this.isABU && this.isNew === false) {
      this.isChangeSAR = true;
      this.selectedActionType = '2';
      this.selectedChangeType = '3';
      this.isInventoryLevelUpdate = true;
    }
    else if (this.newActionInputParam.changeType === 'Change Data' && this.isNew === false) {
      this.isChangeSAR = true;
      this.selectedActionType = '2';
      this.selectedChangeType = '1';
      this.isInventoryLevelUpdate = false;
    }
    else if (this.newActionInputParam.changeType === 'Add New Item' && this.isNew === false) {
      this.isChangeSAR = false;
      this.isAddNewItem = true;
      this.equipmentSelect = true;
      this.selectedActionType = '1';
      this.selectedChangeType = '0';
      this.isInventoryLevelUpdate = false;
    }
  }

  actionSubTypeChange(value: string) {
    this.newActionInputParam.changeType = 'Change Data';
    if (value === '2') {
      this.newActionInputParam.changeType = 'Extension MRP Update';
    }

    if (value === '3') {
      this.newActionInputParam.changeType = 'Inventory Level Update';
      this.isDraftavailable = true;
      this.isEquipmentShown = false;
    }

    else {
      this.isDraftavailable = false;
    }
  }

  onValueChange(value: string[]) {
    this.selectedEquipments = value;
    let formattedArray = this.selectedEquipments[0].split(", ").map((item: string) => item.trim());
    let equipment: EquipmentDto = {
      itemPartRanking: '',
      equipmentCriticality: '',
      equipmentTags: []
    };

    this.requestLineService.getEquipmentProperties(formattedArray)
      .subscribe(response => { 
        this.equipmentCriticality = response.criticality;
        this.itemPartRanking = response.partRanking;
        equipment.equipmentCriticality = this.equipmentCriticality;
        equipment.itemPartRanking = this.itemPartRanking;       
      }
    );

    equipment.equipmentTags = formattedArray;
    this.equipmentDataService.setData(equipment);
  }

  handleFilter(value: string) {
    this.data = this.equipment.filter(
      (s) => s?.toLowerCase().indexOf(value!.toLowerCase()) !== -1
    );
  }

  ngOnDestroy(): void {
    sessionStorage.removeItem('sarnewaction');
  }

  actionTypeChange(value: string) {
    this.selectedChangeType = '0';
    this.isChangeSAR = false;
    this.newActionInputParam.changeType = 'Add New Item';
    if (value === '1') {
      this.isEquipmentShown = true;
      this.equipmentSelect = true;
    }
    if (value === '2') {
      this.equipmentSelect = false;
      this.isEquipmentShown = false;
      this.isChangeSAR = true;
    }
  }

  public onFilterChange(searchTerm: string): void {
    if (searchTerm && searchTerm.trim() !== '') {
      this.data = [];
      this.requestLineService.getEquipment(searchTerm).pipe(
        switchMap(result => {
          return of(result);
        })
      ).subscribe(result => {
        this.data = result;
      });
    }
  }

  public onRemove(e: ChipRemoveEvent): void {
    const index = this.selectedEquipments
      .map((c) => c)
      .indexOf(e.sender.label);
    this.selectedEquipments.splice(index, 1);
  }

  navViewSAR() {
    const path = `false/false/${this.newActionInputParam.requestId}`;
    this.router.navigate([`./${requestConst.viewSAR}/${path}`], {
      state: { isManage: false, isCreate: false, requestId: this.newActionInputParam.requestId }, relativeTo: this.route.parent
    });
  }

  saveDraft() {
    const formData = new FormData();
    formData.append('requestId', this.tempActionRequest.requestId!.toString());
    formData.append('requestIssueId', this.tempActionRequest.requestIssueId!.toString());
    formData.append('requestIssueTypeId', this.tempActionRequest.requestIssueTypeId!.toString());
    formData.append('comment', this.tempActionRequest.comment!);
    formData.append('createdBy', this.tempActionRequest.createdBy!);
    formData.append('modifiedBy', this.tempActionRequest.modifiedBy!);
    if (this.tempActionRequest.attachments!.length) {
      for (let attachment of this.tempActionRequest.attachments!) {
        formData.append('attachments', attachment);
      }
    }
    else {
      formData.append('attachments', '');
    }
    this.tempActionService.createTempAction(formData).subscribe((response: any) => {
      this.navViewSAR();
    })
  }

  saveAndExit() {
    if ((this.commonService.isNullOrEmptyOrUndefined(this.lineAssignment!.assignedGroupId!) || this.commonService.isNullOrEmpty(this.lineAssignment!.comment!)) 
                && !this.lineAssignment?.isMixedValues) {
      this.isGoupSelected = false;
      this.commonService.showNotificationMessage(SharedConst.validationMessage, 'error', 'center');
    }
    else {
      let userId: any = this.lineAssignment!.assignedUserId!;
      if (this.commonService.isNullOrEmptyOrUndefined(this.lineAssignment!.assignedUserId!.toString())) {
        userId = null;
      }
      let groupId: any = this.lineAssignment!.assignedGroupId!;

      if (this.commonService.isNullOrEmptyOrUndefined(this.lineAssignment!.assignedGroupId!)) {
        groupId = null;
      }
      this.isGoupSelected = true;

      const formData = new FormData();
      formData.append('requestId', this.lineAssignment!.requestId!.toString());
      formData.append('requestIssueId', this.lineAssignment!.requestIssueId!.toString());
      formData.append('requestIssueTypeId', this.lineAssignment!.requestIssueTypeId!.toString());
      formData.append('businessUnitId', this.lineAssignment!.businessUnitId!.toString());
      formData.append('assignedGroupId', groupId);
      formData.append('assignedUserId', userId);
      formData.append('state', this.lineAssignment!.state!.toString());
      formData.append('comment', this.lineAssignment!.comment!);
      formData.append('isGeneralComment', this.lineAssignment!.isGeneralComment!.toString());
      formData.append('createdBy', this.lineAssignment!.createdBy!);
      formData.append('modifiedBy', this.lineAssignment!.modifiedBy!);

      for (let attachment of this.lineAssignment!.attachments!) {
        formData.append('attachments', attachment);
      }

      this.requestLineService.UpdateLineAssignment(formData).subscribe(response => {
        let changeType: string = this.newActionInputParam.changeType ? this.newActionInputParam.changeType.replace(/ /g, "_") : '';
        if (changeType === 'Inventory_Level_Update') {
          const path = `false/false/${this.newActionInputParam.requestId}`;
          this.router.navigate([`./${requestConst.viewSAR}/${path}`], {
            state: 
            { 
              requestId: this.newActionInputParam.requestId,
              isInventoryLevelUpdate: true,           
            }, relativeTo: this.route.parent
          });
        }

        else {
          this.router.navigate([
            `../${requestConst.approvalDetail}/${this.newActionInputParam.requestId}/${this.newActionInputParam.requestNumber}/${this.newActionInputParam.requestIssueId}/${this.newActionInputParam.actionNumber}/${changeType}`],
            {
              state:
              {
                requestId: this.newActionInputParam.requestId,
                requestNumber: this.newActionInputParam.requestNumber,
                requestIssueId: this.newActionInputParam.requestIssueId,
                actionNumber: this.newActionInputParam.actionNumber,
                changeType: this.newActionInputParam.changeType,
              },
              relativeTo: this.route
            });
        }        
      })
    }
  }

  cancel() {
    const dialog: DialogRef = this.dialogService.open({
      title: 'Confirmation',
      content: 'If you cancel, this action will not be created. Cancel?',
      actions: [
        { text: 'OK', primary: true },
        { text: 'Cancel' }
      ]
    });

    dialog.result.subscribe((result) => {
      if (result instanceof DialogCloseResult) {
        return;
      } 
      else {
        if (result['text'] === 'OK') {
          this.requestLineService.DeleteLineItems(this.deleteLineItem).subscribe((response) => {
            this.navViewSAR();
          });
        } else {
          return;
        }
      }
    });     
  }

  addTempActionRequest(item: any) {
    this.tempActionRequest = { ...item };
  }

  addLineAssignment(item: any) {
    this.lineAssignment = { ...item };
  }

  cancelAction(data: DeleteLineItemDto) {
    this.deleteLineItem = { ...data };
  }

  setDraftAvailability(isDraftavailable: any) {
    this.isDraftavailable = isDraftavailable;
  }
}
